import { useState } from "react";
//@ts-ignore
import ProfileImg from "../../../../assets/images/profilepic.png";
import { staffs } from "../../../ViewAgentProfile/dummyData";

const StaffItem = (staff: any) => {
  const [showDetails, setShowDetails] = useState(false);
  return (
    <>
      <button
        onClick={() => setShowDetails(true)}
        className="bg-[#fafafa] p-2 grid grid-cols-[1.5fr_1fr_0.7fr_0.5fr] rounded-md relative w-full"
      >
        <div className="flex items-center gap-3 absolute top-0 left-3">
          <img src={staff?.image} className="rounded-full h-12 w-12" />
          <div className="flex flex-col pt-1 gap-1">
            <span className="font-montserrat text-charcoal font-semibold max-[900px]:w-min">
              {staff?.name}
            </span>
            <div className="flex items-center gap-1">
              <div className="w-[6px] h-[6px] bg-[#23BD33] rounded-full animate-pulse" />
              <span className="font-montserrat text-charcoal italic text-xss max-[900px]:w-min">
                {staff?.status}
              </span>
            </div>
          </div>
        </div>
        <div />
        <span className="font-montserrat text-charcoal font-semibold text-xs max-[900px]:w-min">
          {staff?.position}
        </span>
        <span className="font-montserrat text-secondary font-medium text-xs max-[900px]:w-min">
          Contact details
        </span>
        <span className="font-montserrat text-charcoal text-[10px] max-[900px]:w-min">
          RU-324DMG
        </span>
      </button>
      {/* <Modal isOpen={showDetails} containerStyle="w-max">
          <DetailModal data={staff} setShowDetails={setShowDetails} />
        </Modal> */}
    </>
  );
};

const Staff = () => {
  return (
    <div className="flex flex-col items-center h-full w-full">
      <span className="font-bold underline text-sm">
        Elite Staffing Solutions Staff Members
      </span>

      <div className="flex-1 overflow-y-auto no-scrollbar w-full">
        <div className="flex flex-col w-full gap-12 pt-8">
          {staffs?.map((staff) => {
            return <StaffItem key={staff?._id} {...staff} />;
          })}
        </div>
      </div>
    </div>
  );
};

export default Staff;
